import React, { Component } from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { mediaQueries } from 'transfer/styles'
const { phoneLandscapeMax: mobile } = mediaQueries

const bubble = {
  main: {
    position: 'absolute',
    minHeight: '24px',
    backgroundColor: '#f5fbfe',
    border: '1px solid #50c7f9',
    borderRadius: '5px',
    color: '#333',
    display: 'inline-block',
    padding: '12px 12px',
    whiteSpace: 'pre-wrap',
    zIndex: '-200', // this is needed because the bubble somehow overlays over the 'click-able alert icon'
    maxWidth: '288px',
    width: ['1060%', 'max-content'], // the 1060% is based on the width of the parent...which is the target and usually a small icon
    textAlign: 'left',
    [mobile]: {
      width: 'max-content',
    },
  },
  topleft: {
    top: '50%',
    left: '50%',
    transform: 'translate(-22.5px,25px)',
  },
  bottomleft: {
    bottom: '50%',
    left: '50%',
    transform: 'translate(-22.5px,-25px)',
  },
  topmiddle: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,25px)',
  },
  bottommiddle: {
    bottom: '50%',
    left: '50%',
    transform: 'translate(-50%,-25px)',
  },
  topright: {
    top: '50%',
    right: '50%',
    transform: 'translate(22.5px,25px)',
  },
  bottomright: {
    bottom: '50%',
    right: '50%',
    transform: 'translate(22.5px,-25px)',
  },
}

/*
 *  triangleSolid and triangleBorder are the special css to make the triangle for the speech bubble
 *
 *  currently supports 6 different placements
 *
 *  1) top-left
 *  2) top-middle
 *  3) top-right
 *  4) bottom-left
 *  5) bottom-middle
 *  6) bottom-right
 */
const triangleSolid = {
  main: {
    '&:after, &:before': {
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      content: '""',
      position: 'absolute',
      [mobile]: {
        borderLeft: '11px solid transparent',
        borderRight: '11px solid transparent',
      },
    },
  },
  top: {
    '&:after, &:before': {
      bottom: '100%',
    },
  },
  bottom: {
    '&:after, &:before': {
      top: '100%',
    },
  },
  left: {
    '&:after, &:before': {
      left: '0%',
      marginLeft: '13px',
      [mobile]: {
        marginLeft: '12px',
      },
    },
  },

  middle: {
    '&:after, &:before': {
      left: '50%',
      marginLeft: '-10px',
    },
  },

  right: {
    '&:after, &:before': {
      right: '0%',
      marginRight: '12px',
      [mobile]: {
        marginRight: '11px',
      },
    },
  },
}

const triangleBorder = {
  main: {
    '&:before': {
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      [mobile]: {
        borderLeft: '11px solid transparent',
        borderRight: '11px solid transparent',
      },
    },
  },
  top: {
    '&:before': {
      borderBottom: '10px solid',
      borderBottomColor: 'inherit',
      [mobile]: {
        borderBottom: '11px solid',
        borderBottomColor: 'inherit',
      },
    },
    '&:after': {
      borderBottom: '10px solid #f5fbfe',
      marginBottom: '-1px',
    },
  },
  bottom: {
    '&:before': {
      borderTop: '10px solid',
      borderTopColor: 'inherit',
      [mobile]: {
        borderTop: '11px solid',
        borderTopColor: 'inherit',
      },
    },
    '&:after': {
      borderTop: '10px solid #f5fbfe',
      marginTop: '-1px',
    },
  },
  left: {
    '&:before': {
      marginLeft: '12px',
      left: '0%',
    },
  },
  middle: {
    '&:before': {
      marginLeft: '-11px',
      [mobile]: {
        marginLeft: '-10px',
      },
    },
  },
  right: {
    '&:before': {
      marginRight: '11px',
      right: '0%',
    },
  },
}

const bubbleHidden = {
  textAlign: 'left',
  transition: 'all 0.25s ease-in-out',
  maxHeight: '0px',
  opacity: '0',
}

const bubbleShow = {
  maxHeight: '250px',
  opacity: '1',
  zIndex: '1',
}

const verticalPositionOptions = ['top', 'bottom']
const horizontalPositionOptions = ['left', 'middle', 'right']

class ToolTip extends Component {
  displayName: 'vx-tool-tip'

  static propTypes = {
    isDebug: PropTypes.bool,
    content: PropTypes.string.isRequired,
    verticalPosition: PropTypes.string,
    horizontalPosition: PropTypes.string,
    isVisible: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    verticalPosition: 'top',
    horizontalPosition: 'middle',
    content: 'looks like you forgot some content =(',
    isDebug: false,
    isVisible: false,
  }

  state = {
    verticalPosition: this.props.verticalPosition,
    horizontalPosition: this.props.horizontalPosition,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
  }

  render() {
    const { content } = this.props
    const { verticalPosition, horizontalPosition } = this.state
    const vertical = verticalPositionOptions.includes(verticalPosition)
      ? verticalPosition
      : 'top'
    const horizontal = horizontalPositionOptions.includes(horizontalPosition)
      ? horizontalPosition
      : 'left'

    // dynamically style the triangle to be on top or bottom and left, middle or right
    // of the main text bubble
    const TooltipBubbleSpan = glamorous.span(
      bubble.main,
      bubble[`${vertical}${horizontal}`],
      triangleSolid.main,
      triangleSolid[vertical],
      triangleSolid[horizontal],
      triangleBorder.main,
      triangleBorder[vertical],
      triangleBorder[horizontal],
      bubbleHidden,
      this.props.isVisible && bubbleShow
    )

    return (
      <TooltipBubbleSpan className={`vx_text-legal`}>
        {/* TODO: support multiple line content? */}
        {content}
      </TooltipBubbleSpan>
    )
  }
}

export default ToolTip
